import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import SectionProducts from "./Sections/SectionProducts.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import styles from "assets/jss/material-kit-pro-react/views/ecommerceStyle.jsx";

class EcommercePage extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
				<div className={classNames(classes.main)}>
					<SectionProducts />
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(EcommercePage);
